import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as createWizardReducer from "containers/CreateWizard/reducer";

import BusinessChooseSuccess from "components/CreateWizard/Business/BusinessChooseSuccess";

class BusinessChooseSuccessContainer extends React.PureComponent {
  handleUpdateSuccess(sel) {
    const { index, updateSuccess, updateStep } = this.props;

    updateStep(index + 1);

    return updateSuccess(sel);
  }

  render() {
    return <BusinessChooseSuccess {...this.props} updateSuccess={(success) => this.handleUpdateSuccess(success)} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSuccess: (success) => dispatch(setupReducer.updateSuccess(ownProps.id, success)),
  updateStep: (step) => dispatch(createWizardReducer.updateStep(step)),
  updateDescription: (desc) => dispatch(blueprintReducer.updateDescription(ownProps.id, desc)),

  updateEndState: (endState) => dispatch(setupReducer.updateEndState(ownProps.id, endState)),

  updateIgnored: (column, isIgnored) => dispatch(setupReducer.updateIgnored(ownProps.id, column, isIgnored)),

  updateBusinessSubgroupLabel: (index, label) =>
    dispatch(setupReducer.updateBusinessSubgroupProp(ownProps.id, index, "label", label)),
  updateBusinessSubgroupValue: (index, value) =>
    dispatch(setupReducer.updateBusinessSubgroupProp(ownProps.id, index, "value", value))
});

const mapStateToProps = (state, ownProps) => {
  const selectedDataset = setupReducer.getDatasetFromSetup(state, ownProps.id);
  const outcomeType = selectedDataset ? setupReducer.getOutcomeType(state, ownProps.id) : null;
  return {
    selectedDataset: selectedDataset,
    outcomeType: outcomeType,

    selectedSuccess: setupReducer.getSuccess(state, ownProps.id),
    successOptions: setupReducer.getSuccessOptions(state, ownProps.id),

    step: createWizardReducer.getStep(state),

    correlations: setupReducer.getCorrelationsFromDataset(state, ownProps.id),
    ignored: setupReducer.getIgnored(state, ownProps.id),

    subgroups: setupReducer.getBusinessSubgroups(state, ownProps.id),
    subgroupOptions: setupReducer.getBusinessSubgroupOptions(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(BusinessChooseSuccessContainer);
